/**
 * Traduções de perfil
 * Inclui: Editar perfil, upload de avatar, modificação de apelido
 */
export default {
  accountManagement: 'Gerenciamento de conta',
  termsOfUse: 'Termos de Uso',
  privacyPolicy: 'Política de Privacidade',
  communityGuidelines: 'Diretrizes da Comunidade',
  logOut: 'Sair',
  id: 'ID',
  enterNickname: 'Digite o apelido',
  nicknameTooShort: 'O apelido deve ter pelo menos 2 caracteres',
  nicknameTooLong: 'O apelido não pode exceder 20 caracteres',
  updateSuccess: 'Atualização bem-sucedida',
  invalidImageType: 'Por favor, selecione um arquivo de imagem',
  imageSize2MBLimit: 'O tamanho da imagem não pode exceder 2MB',
  imageNotSquare: 'Por favor, envie uma imagem quadrada (largura igual à altura)',
  invalidImage: 'Arquivo de imagem inválido',
  uploadLimitExceeded: 'Falha no upload: limite de upload excedido',
  uploadDailyLimitExceeded: 'Falha no upload: limite diário de upload excedido',
}
